import type { AssessmentType } from '@mend/types/assessment';
import type { Response } from '#types/common.ts';

import { api } from '../http-clients.ts';

export function getAssessments(): Promise<AssessmentType[]> {
  return api
    .get<Response<{ assessments: AssessmentType[] }>>('/assessment')
    .then((res) => res.data.payload.assessments);
}
